import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table";
import { jobs } from "../../../../../../redux/jobs/action";
import { selectListItems } from "../../../../../../redux/library/selector";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { selectJobsListItems } from "../../../../../../redux/jobs/selector";

const ManagementJobs = () => {
  const dispatch = useAppDispatch()
  const libraryData = useSelector(selectListItems)
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const itemsData = useSelector(selectJobsListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Message.OrderId', headerName: 'OrderId', searchField: 'Message.OrderId', sortable: true, filter: true, filterType: 'text' },
      { field: 'Message.TransportAgentName', headerName: 'Agent', },
      { field: 'Message.PhoneNumber', headerName: 'Phone', },
      { field: 'Message.IsRTOJOB', headerName: 'RTO JOB', cellRenderer: 'yesNoRenderer' },
      { field: 'Message.IsQCTask', headerName: 'QC Task', cellRenderer: 'yesNoRenderer' },
      {
        field: 'Message.ShipmentInfo.ShippingStatusId',
        headerName: 'Shipment Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.ShippingStatus },
        sortable: true,
        filter: false, isRowColorDecider: true
      },
      { field: 'Message.PickupCode', headerName: 'Pickup Code' },
      { field: 'Message.PickupInfo.location', headerName: 'From Address', isAddressFormat: true },
      { field: 'Message.DeliveryCode', headerName: 'Delivery Code' },
      { field: 'Message.DeliveryInfo.location', headerName: 'To Address', isAddressFormat: true },
      { field: 'Message.JobNotes', headerName: 'Notes', },
      { field: 'Message.CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true }
    ]);
  }

  const fetchJobs = async () => {
    await dispatch(jobs.resetAction({ actionType: 'list' }))
    await dispatch(jobs.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/jobs/list`, entity: 'jobs', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",


      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchJobs()
  }, [pageData, pageSize])

  const handleDelete = (data: any) => {
    dispatch(jobs.delete({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/jobs/delete`,
      entity: 'jobs',
      jsonData: {
        Records: [
          {
            Context: {},
            Message: {
              Id: data?.Message?.Id
            }

          }
        ]
      }
    })).then(() => {
      fetchJobs()

    });
  }
  const handleEdit = (data: any) => {
    navigate(`${data?.Message?.Id}`)
  }
  const handleReloadData = () => {
    fetchJobs()
  }
  const additionButtons: any = [

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Message.OrderId",
        FieldText: "Message.OrderId",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(jobs.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/jobs/list`,
      entity: 'jobs',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }
  return (
    <>
      {itemsData?.isLoading ? <PageLoader />
        :
        <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
          enableFilter={true} onSearch={handleSearch} paginationData={itemsData?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} onDelete={handleDelete} headingName="Jobs" />
      }
    </>
  );
};

export default ManagementJobs;


